import Vue from 'vue';
import SMP_CONFIG from '../util/smp_config';
import { find } from 'lodash';
import utils from '@/services/utils';

Vue.filter('optionTranslate', function (item) {
  const LANG = utils.getCurrentLanguage();
  const COUNTRY = SMP_CONFIG.countryConfig.countryCode;
  let name = '';
  if (item) {
    name = item.serviceName || item.name || item.type || item.key || item;// serviceName is used in services of offerSearch
    if (item.translations && item.translations.length) {
      const translation = find(item.translations, { languageCode: LANG, countryCode: COUNTRY });
      // specialTranslation should not be used, if BE updates to countryCode and languageCode
      const specialTranslation = find(item.translations, { language: LANG, country: COUNTRY });

      if (translation && translation.translation) {
        name = translation.translation;
      } else if (specialTranslation && specialTranslation.translation) {
        name = specialTranslation.translation;
      }
    }
  }
  return name;
});
